import application from 'application/application';

const controller = 'DefaultAddProcessesController';

application.controller(controller, [
	'$state',
	'$rootScope',
	'$scope',
	'$timeout',
	'$http',
	'API',
	'helper',
	'notification',
	'permissions',
	'authentication',
	'$stateParams',
	(
		$state,
		$rootScope,
		$scope,
		$timeout,
		$http,
		API,
		helper,
		notification,
		permissions,
		authentication,
		$stateParams
	) => {
		//const productAdvise = authentication.getUserData('idProdutoAdvise');

		const idCliente = parseInt(authentication.getUserData('idCliente'));
		const idUsuarioCliente = parseInt(
			authentication.getUserData('idUsuarioCliente')
		);
		const groupUserData = JSON.parse(localStorage.getItem('__groupUserData__'));

		$scope.groupSelected = localStorage.getItem('__groupSelected__');

		$scope.blockOabRegister = true;

		$scope.fontesDisponiveis = [];

		$scope.contarFontesDisponiveisMarcadas = () => {
			return $scope.fontesDisponiveis.reduce((total, source) => {
				return total + (source.__checked__ ? 1 : 0);
			}, 0);
		};

		$scope.verificationNumber = (number, cnj, valid) => {
			if (cnj) {
				let regex = /^[0-9][0-9\-_\.\/]*$/;

				return regex.test(number);
			} else {
				return valid;
			}
		};

		$scope.treatCNJ = input => {
			if (input)
				$scope.createProcess.numeroProcesso = input.replace(/["a-zA-Z\\]/g, '');
		};

		// Ativo -1
		// Inativo -2
		// Excluido -3
		$scope.groups = helper.responseStore();

		$scope.errorGroup = true;
		$scope.mostrarCadastroAgil = false;

		$scope.recordGroups = responseStore => {
			if ($scope.groupSelected != 'true') {
				$scope.profileName = authentication.getUserData('nome');
				$scope.errorGroup = false;

				return;
			}

			$http({
				...helper.http(API.groupUsers, 'GET'),
				params: {
					...helper.httpFields([
						'idGrupo',
						'nomeGrupo',
						'idCliente',
						'idSituacaoGrupo',
						'situacaoGrupo',
						'listaUsuariosGrupo.idUsuarioXGrupo',
						'listaUsuariosGrupo.idUsuarioCliente',
						'listaUsuariosGrupo.nomeUsuario',
						'listaUsuariosGrupo.administrador',
						'listaUsuariosGrupo.ativo'
					]),
					IdsGrupoUsuarios: groupUserData.idGrupo,
					IdsClientes: [idCliente],
					IdsSituacaoGrupoUsuario: [-1]
				}
			})
				.then(response => {
					if (!response.data.itens.length > 0) {
						$scope.txtError = 'Grupo não encontrado.';
						$('#modalAlert').modal('show');

						return;
					}

					if (!response.data.itens[0].listaUsuariosGrupo.length > 0) {
						$scope.txtError = 'Grupo não possui usuários.';
						$('#modalAlert').modal('show');

						return;
					}

					let group = response.data.itens[0];

					let userGroup = group.listaUsuariosGrupo.filter(
						userGroup =>
							parseInt(userGroup.idUsuarioCliente) === idUsuarioCliente &&
							userGroup.administrador &&
							userGroup.ativo
					);

					if (!userGroup.length > 0) {
						$scope.txtError =
							'É necessário pertencer ao grupo e possuir privilégios de administrador.';
						$('#modalAlert').modal('show');

						return;
					}

					$scope.errorGroup = false;

					responseStore.setItems(group);
				})

				.finally(() => responseStore.setReady(true));
		};

		$scope.recordGroups($scope.groups);

		$scope.openGenericModal = id => {
			if (id == '#modalRegisterOAB') {
				$rootScope.setModalRegisterOabData();
			}

			setTimeout(() => {
				$(id).modal('show');
			}, 300);
		};

		$scope.closeModal = () => {
			$('#modalAlert').modal('hide');

			let number = null;

			if (permissions.has('recordPublications')) number = '2';
			else if (permissions.has('createMovements')) number = '1';

			setTimeout(() => {
				$state.go(`root.default.movements.list${number}`, {
					inherit: false,
					reload: true
				});
			}, 250);
		};

		$scope.step = 1;

		$scope.createProcess = {
			idUF: '',
			idOrgaoJudiciario: '',
			instancia: -2,
			numeroProcesso: $state.params.n || '',
			consultaCNJ: true
		};

		/** @TODO: Descrever. */
		$scope.changeDegree = (branches, item) => {
			if (item.instancia === -3) item.idUF = '';

			$scope.recordJudicialBranches(branches, item);
		};

		/**
		 * Recupera UF.
		 *
		 * @param {ResponseStore} responseStore - Instância de armazenamento de resposta.
		 *
		 * @example
		 * // Cria uma instância de armazenamento de resposta.
		 * $scope.federativeUnits = helper.responseStore();
		 *
		 * // Recupera as unidades federativas.
		 * $scope.recordFederativeUnits($scope.federativeUnits);
		 */
		$scope.federativeUnits = helper
			.responseStore()

			.setItemsPerPage(-1);

		$scope.recordFederativeUnits = responseStore => {
			$http({
				...helper.http(API.federativeUnits, 'GET'),
				params: {
					...helper.httpFields(['id', 'sigla']),
					ativo: true,
					paginaAtual: responseStore.getCurrentPage(),
					registrosPorPagina: responseStore.getItemsPerPage(),
					...responseStore.getFilters()
				}
			})
				.then(response => responseStore.setItems(response.data.itens))

				.finally(() => responseStore.setReady(true));
		};

		$scope.recordFederativeUnits($scope.federativeUnits);

		/**
		 * Recupera orgão judiciário.
		 *
		 * @param {ResponseStore} responseStore - Instância de armazenamento de resposta.
		 *
		 * @example
		 * // Cria uma instância de armazenamento de resposta.
		 * $scope.judicialBranches = helper.responseStore();
		 *
		 * // Recupera os orgaçãos judiciários.
		 * $scope.recordJudicialBranches($scope.judicialBranches);
		 */
		$scope.judicialBranches = helper
			.responseStore()

			.setItemsPerPage(-1);

		$scope.recordJudicialBranches = (responseStore, item) => {
			responseStore

				.setNotReady()

				.setItems([]);

			if (item.instancia !== -3 && !item.idUF) return false;

			$http({
				...helper.http(API.judicialBranches, 'GET'),
				params: {
					...helper.httpFields(['id', 'nome']),
					ativo: true,
					idUF: item.idUF,
					idGrauJurisdicao: item.instancia,
					paginaAtual: responseStore.getCurrentPage(),
					registrosPorPagina: responseStore.getItemsPerPage(),
					...responseStore.getFilters()
				}
			})
				.then(response => responseStore.setItems(response.data.itens))

				.finally(() => responseStore.setReady(true));
		};

		/** Cria um responseStore para fontes parâmetros. */
		$scope.sources = helper
			.responseStore()

			.setItemsPerPage(-1);

		/** @TODO: Descrever. */
		$scope.findSources = (responseStore, item, step) => {
			responseStore.setLoading();

			let filters = {
				numeroProcesso: item.numeroProcesso.replace(/[^\d]+/g, ''),
				consultaCNJ: item.consultaCNJ,
				idOrgaoJudiciario: item.idOrgaoJudiciario
			};

			if ($scope.groupSelected == 'true') {
				filters = Object.assign(filters, {
					idGrupoUsuarios: groupUserData.idGrupo
				});
			}

			$http({
				...helper.http(API.sourceParamsCNJ, 'GET'),
				params: {
					...helper.httpFields(['*']),
					paginaAtual: responseStore.getCurrentPage(),
					registrosPorPagina: responseStore.getItemsPerPage(),
					...filters
				}
			})
				.then(response => {
					if (response.data.itens.length) {
						responseStore.setItems(response.data.itens);

						$scope.fontesDisponiveis = responseStore
							.getItems()
							.filter(function(source) {
								return !source.flCadastroIndisponivel;
							});

						$scope.step = step;
					} else
						notification.push({
							body:
								'Não foi possível encontrar o processo! Verifique se a numeração do processo está correta ou se este processo já está cadastrado.',
							type: 'danger',
							duration: 7000
						});
				})

				.finally(() => responseStore.setNotLoading().setReady(true));
		};

		$scope.mensagemTooltip = source => {
			if (
				!source ||
				!source.flCadastroIndisponivel ||
				!source.tempoParaDisponibilizacao
			) {
				return '';
			}

			const partes = source.tempoParaDisponibilizacao.split(':');

			const horas = Number(partes[0]);
			const minutos = Number(partes[1]);

			if (horas > 0) {
				return `O cadastro deste processo nesta fonte foi solicitado recentemente. Aguarde ${horas} h ${minutos} min para solicitar novamente.`;
			}

			if (minutos > 0) {
				return `O cadastro deste processo nesta fonte foi solicitado recentemente. Aguarde ${minutos} min para solicitar novamente.`;
			}

			return 'O cadastro deste processo nesta fonte foi solicitado recentemente. Aguarde menos de 1 minuto para solicitar novamente.';
		};

		/** Cria um responseStore para processos. */
		$scope.fontsProcesses = helper
			.responseStore()

			.setItemsPerPage(-1);

		/** @TODO: Descrever. */
		$scope.searchFontsProcesses = (responseStore, sources, create) => {
			responseStore.setLoading();

			let items = {
				flPesqAndamentoAuto: true,
				flPesqPublicacaoAuto: false,
				flDonoProcesso: true,
				idSitPesqProcUsuarioCliente: -5,
				processos: []
			};

			if ($scope.groupSelected == 'true') {
				let objGroup = {
					idGrupoUsuarios: groupUserData.idGrupo
				};

				items = Object.assign(items, objGroup);
			} else {
				let objUser = {
					idUsuarioClienteXFuncionalidade: permissions.getProp(
						'processesWithAutomaticMovementsSearch',
						'idUsuarioClienteXFuncionalidade'
					),
					idUsuarioCliente: idUsuarioCliente
				};

				items = Object.assign(items, objUser);
			}

			let appendProcess = (create, item) => {
				if (
					items.processos.some(
						item => item.idTipoNumeroProcesso === item.idTipoNumeroProcesso
					)
				)
					items.processos.forEach(
						proc =>
							proc.idTipoNumeroProcesso === item.idTipoNumeroProcesso &&
							proc.fontesPesquisa.push(item)
					);
				else
					items.processos.push({
						numeroProcesso: create.numeroProcesso,
						idTipoNumeroProcesso: item.idTipoNumeroProcesso,
						fontesPesquisa: [item]
					});
			};

			sources
				.filter(item => item.__checked__)
				.forEach(font => {
					if (font.parametrosPesquisa && font.parametrosPesquisa.length)
						font.parametrosPesquisa
							.filter(item => item.__checked__)
							.forEach(param => {
								param.valoresParametro &&
									param.valoresParametro
										.filter(item => item.__checked__)
										.forEach(value => {
											value.idValorParamFonteProc = value.id;

											value.idFonteXTipoPesquisa = font.idFonteXTipoPesquisa;

											value.idTipoNumeroProcesso = font.idTipoNumeroProcesso;

											appendProcess(create, value);
										});
							});
					else appendProcess(create, font);
				});

			$http({
				...helper.http(API.searchFontsProcessClients, 'POST'),
				data: {
					itens: [items]
				},
				messageOverride: {
					success() {}
				}
			})
				.then(() => ($scope.step = 3))

				.finally(() => {
					responseStore.setNotLoading().setReady(true);
				});
		};

		$scope.onInit = () => {
			$scope.blockOabRegister = true;

			$http({
				...helper.http(API.parametersUsers, 'GET'),
				params: {
					...helper.httpFields(['*'])
				}
			}).then(({ data: { itens } }) => {
				if (itens) {
					sessionStorage.setItem(
						'parametros-usuarios',
						JSON.stringify(itens[0])
					);
				}
				$scope.blockOabRegister = false;
			});
		};

		$scope.focusElement = () => {
			setTimeout(() => {
				const element = $scope.createProcess.consultaCNJ
					? 'numberOne'
					: 'numberTwo';

				document.getElementById(element).focus();
			}, 200);
		};

		$scope.backStepOne = () => {
			if ($stateParams.n)
				$state.go(
					'root.default.addProcesses',
					{},
					{
						inherit: false
					}
				);

			$scope.nextStep(1, true);
		};

		$scope.nextStep = (step, isNew) => {
			if (isNew) $scope.createProcess.numeroProcesso = '';

			$scope.step = parseInt(step);

			$scope.focusElement();
		};

		$scope.checkForQuickRegisterPermission = () => {
			const mostrarCadastroAgil = localStorage.getItem(
				'__mostrarCadastroAgil__'
			);

			if (mostrarCadastroAgil == 'true') {
				$scope.mostrarCadastroAgil = true;
			}
		};

		$scope.checkForQuickRegisterPermission();

		$scope.onInit();
	}
]);

export default controller;
